import type { FleetProfileStatus } from '@immo/api-contract';

/** The phase a host reports for a lane the operator stopped (fleet-agent ADR 0013) — `…` adds "after its round". */
const STOPPED_BY_OPERATOR = 'stopped by the operator';

/**
 * Whether the host says the operator stopped this lane. The phase rides the untyped status as the `Phase` field (and
 * as the title when no ticket is held), so both are read.
 */
export function isStoppedByOperator(profile: Pick<FleetProfileStatus, 'state' | 'title' | 'fields'>): boolean {
  if (profile.state !== 'stopped') return false;

  const phase = profile.fields.find((field) => field.label === 'Phase')?.value ?? profile.title ?? '';

  return phase.startsWith(STOPPED_BY_OPERATOR);
}
